import { Component, OnInit, ViewChild, EventEmitter, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormGroup, FormControl, FormArray, Validators, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { DataSource } from '@angular/cdk/collections';
import { Subject, Observable } from 'rxjs/Rx';
import {
    MatDialog, MatTabsModule, MatTabChangeEvent, MatDialogRef,
    MatTooltipModule, MatRadioModule, MatPaginator, MatSort
} from '@angular/material';
import { DataTableModule, SharedModule } from 'primeng/primeng';
import { MAT_DIALOG_DATA } from '@angular/material';
import { User } from '../users/user.model';
import { Audit } from '../audits/audit.model';
import { UserService } from '../users/user.service';
import { AuditService } from '../audits/audit.service';
import { UserProfileService } from '../userprofile/userprofile.service';
import { UserProfile } from '../userprofile/userprofile.model';
import { UserEditComponent } from '../users/user-edit/user-edit.component';
import { CalendarEditComponent } from '../calendar/calendar-edit/calendar-edit.component';
import { CalendarAddComponent } from '../calendar/calendar-add/calendar-add.component';
import { SearchService } from '../shared/search.service';
import { SearchFilter } from '../shared/searchFilter.pipe';
import { CalendarService } from './calendar.service';
import { Calendar } from './calendar.model';
import { CalendarEventType } from './calendar-event-type.model';
import { CalendarEventTypeService } from './calendar-event-type.service';
import { CalendarEventResult } from './calendar-event-result.model';

@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.css']
})

export class CalendarComponent implements OnInit {
    public searchToken: string;
    private isAuthenticatedSubscription: any;
    public isAdmin = true;
    eventDuration: string;
    public todayDate = new Date();
    public pageNumber = 1;
    public pageSize = 15;
    public includeWeekends = false;
    public minCalendarDate = new Date(2016, 12, 1);
    public maxCalendarDate = new Date();
    public calendarForm: FormGroup;
    public dateRows: any;
    public searchableList: any;
    public calendareventresults: CalendarEventResult;
    private calendarEventType: CalendarEventType[] = [];
    public eventTypes: CalendarEventType[];
    public totalPages: number;
    public hasMultiplePages: boolean;
    public firstPage: boolean;
    public lastPage: boolean;

    constructor(
        private searchService: SearchService,
        private fb: FormBuilder,
        public calendarAddDialog: MatDialog,
        public calendarEditDialog: MatDialog,
        private calendarService: CalendarService,
        private eventService: CalendarEventTypeService,
        private userService: UserService) {
        this.calendareventresults = new CalendarEventResult();
        this.searchableList = ['date', 'description', 'time', 'eventType'];
    }

    ngOnInit() {
        this.isAuthenticatedSubscription = this.userService.currentUserAuthenticated.subscribe((currentUser: User) => {
            this.isAdmin = currentUser.isAdmin;
        });
        this.getCalendarEvents();
        this.getEvents();
    }

    getCalendarEvents() {
        this.calendarService.getCalendarEvents(this.pageNumber, this.pageSize, this.includeWeekends)
            .then((result) => {
                this.calendareventresults = result;
                this.totalPages = Math.ceil(this.calendareventresults.totalRecords / this.pageSize);
                this.paginationCheck();
            })
        .catch(error => console.log(error));
    }

    paginationCheck() {
      if (this.totalPages > 1) {
        this.hasMultiplePages = true;
      } else { this.hasMultiplePages = false; }
      if (this.pageNumber == 1) {
        this.firstPage = true;
      }
      else { this.firstPage = false; }
      if (this.pageNumber == this.totalPages) {
        this.lastPage = true;
      }
      else { this.lastPage = false; }
    }

    nextPage(pageNumber: number) {
        if (this.pageNumber < this.totalPages) {
            this.pageNumber = this.pageNumber + 1;
            this.getCalendarEvents();
        }
    }

    prevPage(pageNumber: number) {
        if (this.pageNumber > 1) {
            this.pageNumber = this.pageNumber - 1;
            this.getCalendarEvents();
        }
    }

    openCalendarAddDialog() {
      this.calendarAddDialog.open(CalendarAddComponent, {
        data: {
          pageNumber: this.pageNumber,
          pageSize: this.pageSize
        },
        disableClose: false,
      });
    }

    openCalendarEditDialog(calendarEvent: Calendar) {
        this.calendarEditDialog.open(CalendarEditComponent, {
            data: {
                calendarEvent: calendarEvent,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize
            }
        });
    }


    deleteDate(calendarevent: Calendar) {
        if (confirm('Are you sure you want to delete ' + calendarevent.description + '?')) {
            this.calendarService.deleteCalendarEvent(calendarevent.id);
        }
    }

    getEvents() {
      this.eventService.getCalendarEventTypeCache()
        .then(resp => {
          this.eventTypes = resp;
        });
    }
}




// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/calendar/calendar.component.ts